import React from 'react';
import type {
  AfcSubmissionCandidateReputation,
  CandidateReputation,
} from '@axiom/validation';

import { Accolade } from '../../element/Accolade/Accolade';
import { Icon } from '../../element/Icon/Icon';
import { Layout } from '../../layout/Layout/Layout';
import { PluralizeUtil } from '../../../utils/pluralize-util';

export type CandidateAccoladesProps = {
  candidateReputation:
    | CandidateReputation
    | AfcSubmissionCandidateReputation
    | null;
};
export const CandidateAccolades = ({
  candidateReputation,
}: CandidateAccoladesProps) => {
  const resolvedCandidateReputation = candidateReputation ?? {
    businessJudgementScore: null,
    communicationScore: null,
    createdAt: null,
    displayableSurveyScoreData: false,
    displayCandidateReputation: false,
    hasEnoughRespondents: false,
    legalExpertiseScore: null,
    numberOfAxiomEngagements: 0,
    numberOfEngagements: 0,
    numberOfRespondents: 0,
    numberOfReviews: 0,
    numberOfTestimonials: 0,
    percentageOfReEngagements: null,
    reputationSummary: null,
    responsivenessScore: null,
    updatedAt: null,
    yearsAtAxiom: 0,
  };

  if (resolvedCandidateReputation.numberOfAxiomEngagements === 0) {
    return (
      <Accolade color="yellow" label="New to Axiom" name="NewToAxiom">
        <Icon name="lightning" />
      </Accolade>
    );
  }

  return (
    <Layout
      horizontalGutter="16px"
      verticalGutter="16px"
      wrap
      stackableOn="mobile"
      name="ACCOLADES"
    >
      <div>
        <Accolade
          color="forest green"
          label={`Axiom ${PluralizeUtil({
            text: 'Engagement',
            count: resolvedCandidateReputation.numberOfAxiomEngagements,
          })}`}
          outline
          name="AxiomEngagements"
        >
          {resolvedCandidateReputation.numberOfAxiomEngagements}
        </Accolade>
      </div>
      {resolvedCandidateReputation.percentageOfReEngagements !== null && (
        <div>
          <Accolade
            color="blue"
            label="% Extended"
            outline
            name="PercentExtended"
          >
            {Math.ceil(resolvedCandidateReputation.percentageOfReEngagements)}
          </Accolade>
        </div>
      )}
      <div>
        <Accolade
          color="forest green"
          label={`${PluralizeUtil({
            text: 'Year',
            count: resolvedCandidateReputation.yearsAtAxiom,
          })} on Axiom engagements`}
          outline
          name="YearsAtAxiom"
        >
          {resolvedCandidateReputation.yearsAtAxiom < 1
            ? '<1'
            : Math.floor(resolvedCandidateReputation.yearsAtAxiom)}
        </Accolade>
      </div>
    </Layout>
  );
};
